export default "__VITE_ASSET__BvizI6rF__"